<template>
    <div class="card" :class="classes">
        <div class="card-body" :class="{ 'p-4' : xl }">
            <Icon :icon="icon" v-if="icon" class="float-end mt-1 me-1" :class="lightBackground ? 'text-black-50' : 'text-white-50'" size="2x" />
            <h5 class="card-title mb-0" :class="textClasses">
                <Spinner size="xs" v-if="loading" />
                <span v-else>{{ value | filter(decimals, percentage, money) }}</span>
            </h5>
            <p class="card-text" :class="lightBackground ? 'text-black-50' : 'text-white-50'">{{ legend }}</p>
        </div>
    </div>
</template>

<script>
    import Spinner from '../Loaders/Spinner'

    export default {
        name: 'Stat',
        components: {
            Spinner
        },
        props: {
            color: {
                type: String,
                default: 'success'
            },
            value: [ Number, String ],
            legend: String,
            icon: String,
            decimals: Boolean,
            money: Boolean,
            percentage: Boolean,
            loading: Boolean,
            xl: Boolean
        },
        filters: {
            filter: function (value, decimals, percentage, money) {
                let pattern = '0,0.00'
                if (percentage) {
                    value = value / 100
                    pattern = '0%'
                }
                else if (money) {
                    pattern = decimals ? '$ 0,0.00' : '$ 0,0'
                }
                else {
                    pattern = decimals ?  "0,0.00" : "0,0"
                }
                return this.$options.filters.numeral(value, pattern)
            }
        },
        computed: {
            classes: function() {
                return [
                    { 'bg-primary' : this.color === 'primary' },
                    { 'bg-primary-alt' : this.color === 'primary-alt' },
                    { 'bg-success' : this.color === 'success' },
                    { 'bg-warning' : this.color === 'warning' },
                    { 'bg-info' : this.color === 'info' },
                    { 'bg-danger' : this.color === 'danger' },
                    { 'bg-secondary' : this.color === 'secondary' },
                    { 'bg-light' : this.color === 'light' },
                    { 'bg-white' : this.color === 'white' },
                    { 'bg-dark' : this.color === 'dark' }
                ]
            },
            textClasses: function() {
                return [
                    this.xl ? 'h1' : 'text-md',
                    this.color !== 'light' && this.color !== 'white' ? 'text-white' : ''
                ]
            },
            lightBackground: function() {
                return !this.darkBackground
            },
            darkBackground: function() {
                return this.color === 'dark'
            }
        },
        beforeCreate() {
            this.$options.filters.filter = this.$options.filters.filter.bind(this)
        }
    }
</script>
